import { api } from './client'
import type { GpsState } from './vehicle-gps-api'

export interface FleetVehicle {
    vehicle_id: string
    plate_number: string
    name: string
    status: 'available' | 'in_use' | 'maintenance' | 'retired'
    gps_imei: string
    gps_device_id: string | null
    gps: GpsState | null
    disabled: boolean
    gps_error: 'no_gps' | 'disabled' | 'not_found' | 'upstream' | null
}

export const fleetApi = {
    list: () => api.get<FleetVehicle[]>('/tracking/fleet'),
}
